module.exports = __webpack_public_path__ + "img/slideset_inactive.f99d364f.svg";